import React from 'react';

export default function VisitorConversionCard({ metrics }) {
  const { visitorCount, totalParticipants, conversionRate } = metrics || {};

  // Calculate the circle progress
  const radius = 40;
  const circumference = 2 * Math.PI * radius;
  const progress = (conversionRate / 100) * circumference;
  const offset = circumference - progress;

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h3 className="text-sm font-medium text-gray-500 mb-4">Visitor Conversion</h3>

      <div className="flex items-center gap-6">
        {/* Circular progress indicator */}
        <div className="relative w-24 h-24">
          <svg className="w-full h-full -rotate-90" viewBox="0 0 100 100">
            {/* Background circle */}
            <circle
              cx="50"
              cy="50"
              r={radius}
              fill="none"
              stroke="#e5e7eb"
              strokeWidth="8"
            />
            {/* Progress circle */}
            <circle
              cx="50"
              cy="50"
              r={radius}
              fill="none"
              stroke="#630801"
              strokeWidth="8"
              strokeLinecap="round"
              strokeDasharray={circumference}
              strokeDashoffset={offset}
              style={{ transition: 'stroke-dashoffset 0.5s ease' }}
            />
          </svg>
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="text-xl font-bold text-gray-900">{conversionRate}%</span>
          </div>
        </div>

        <div className="flex-1">
          <div className="space-y-2">
            <div>
              <p className="text-2xl font-bold text-gray-900">{visitorCount}</p>
              <p className="text-sm text-gray-500">visitors to your listing</p>
            </div>
            <div className="text-sm text-gray-600">
              out of <span className="font-medium">{totalParticipants}</span> passport participants
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
